import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  doc,
  deleteDoc,
  updateDoc,
  query,
  where,
  setDoc
} from 'firebase/firestore';
import { db } from '../firebase';

export const getUserDoc = async (uid) => {
  const userRef = doc(db, 'users', uid);
  return await getDoc(userRef);
};

// ✅ Updated to fetch tenants from the 'tenantmaster' collection with tenantName as name
export const getTenants = async () => {
  const tenantsRef = collection(db, 'tenantmaster');
  const snapshot = await getDocs(tenantsRef);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    name: doc.data().tenantName || 'Unnamed Tenant',
    ...doc.data()
  }));
};

export const getAdminTenantByEmail = async (email) => {
  const q = query(collection(db, 'tenantmaster'), where('appAdminEmail', '==', email));
  const snapshot = await getDocs(q);
  if (!snapshot.empty) {
    const data = snapshot.docs[0].data();
    return {
      name: data.tenantName,
      email: data.appAdminEmail,
      tenantId: data.tenantId,
      ...data
    };
  }
  return null;
};

export const getUsersByTenant = async (tenantId) => {
  const usersRef = collection(db, 'users');
  const q = query(usersRef, where('tenantId', '==', tenantId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    userId: doc.id,
    userName: doc.data().displayName || doc.data().userName || '',
    userEmailId: doc.data().userEmailID || doc.data().email || '',
    userMobileNo: doc.data().userMobileNo || doc.data().phone || '',
    role: doc.data().role,
    ...doc.data()
  }));
};

export const addOrUpdateUser = async (userFormData, tenantId, selectedItem) => {
  const userProfileData = {
    email: userFormData.userEmailId,
    userEmailID: userFormData.userEmailId,
    displayName: userFormData.userName,
    userName: userFormData.userName,
    phone: userFormData.userMobileNo,
    userMobileNo: userFormData.userMobileNo,
    role: userFormData.role,
    tenantId: userFormData.role === 'appoperator'
      ? userFormData.tenantId
      : tenantId,
    facilityId: userFormData.facilityId || null,
    createdAt: new Date(),
    status: ['appoperator', 'host', 'appadmin', 'facilityadmin']
      .includes(userFormData.role)
      ? 'pending_activation'
      : 'active'
  };

  if (selectedItem) {
    const ref = doc(db, 'users', selectedItem.userId);
    return await updateDoc(ref, {
      ...userProfileData,
      updatedAt: new Date()
    });
  } else {
    return await addDoc(collection(db, 'users'), userProfileData);
  }
};

export const deleteUser = async (userId) => {
  const ref = doc(db, 'users', userId);
  return await deleteDoc(ref);
};
